/* eslint-disable */
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form, FormSpy } from 'react-final-form'
import classNames from 'classnames'

import Loader from 'common/modules/loader'

import WizardSlider from '@piconetworks/wizard-slider'

import getFields, { isCustomFieldsValid } from 'apps/lib/getFields'
import observers from 'apps/lib/observers'

import ConditionAggregator from '@piconetworks/condition-aggregator'

import WizardRedux from 'common/pkgs/WizardRedux'

import './OfferOptions.module.scss'

const OfferOptions = ({ productOptionId }) => {
    const dispatch = useDispatch()

    const linkColor = useSelector(Loader.selectors.linkColor)
    const contrastColor = useSelector(Loader.selectors.contrastColor)

    const product = useSelector((state) => Loader.selectors.popupGetProductByProductOptionId(state, productOptionId))

    const productFields = useSelector((state) => Loader.selectors.popupGetProductFields(state, product?.id))
    const fields = getFields(productFields)

    const productNewsletters = (product?.newsletters || [])
    const preSelectedNewsletters = (productNewsletters).map(({ id }) => id)

    const skipOfferOptions = !productNewsletters.length && !productFields.length

    let customFieldsValid = fields.length ? false : true

    const newsletters = getFields([{
        id: 'newsletters',
        title: productNewsletters.length ? 'Exclusive Newsletters' : '',
        defaultValue: preSelectedNewsletters,
        description: 'newsletters description',
        type: 'Newsletters',
        required: false,
        order: 15,
    }])

    if (skipOfferOptions) {
        return (
            <WizardRedux.Step
                validate={() => {
                    const errors = {}

                    return errors
                }}
                onSubmit={() => ({})}
                render={({ form }) => {
                    form.submit()
                    return null
                }}
            />
        )
    }

    return (
        <WizardSlider
            title=""
            description=""
            backButton={false}
            wizardHeaderClass="signupFormHeader"
            wizardContentClass="signupFormContent"
            linkColor={linkColor}
        >
            <WizardRedux.Step
                onSubmit={({ values }) => {
                    return {
                        ...values.offerOptions
                    }
                }}
                render={({
                    form,
                }) => (
                    <ConditionAggregator
                        Submit={({ isSubmitting = false }) => (
                            <div className={isSubmitting ? 'loadingSpinner' : ''} >
                                <input
                                    className={classNames('btn btn-primary btn-block')}
                                    style={{
                                        backgroundColor: linkColor,
                                        borderColor: linkColor,
                                        color: contrastColor
                                    }}
                                    type="submit"
                                    value={'Submit'}
                                />
                            </div>
                        )}
                        onSubmit={async (e, data) => {
                            if (!data.state.customFields.isComplete) {
                                throw new Error('finish custom fields')
                            }

                            const { payloads } = data

                            await observers.updateUserNewsletters({
                                dispatch,
                                payload: {
                                    newsletters: payloads?.newsletters?.newsletters
                                },
                            })

                            await observers.updateUserProperties({
                                dispatch,
                                payload: {
                                    customProperties: payloads?.customFields
                                },
                            })

                            return {
                                submitWizard: true,
                            }
                        }}
                        postSubmit={() => {
                            form.submit()
                        }}
                        conditions={{
                            newsletters: {
                                required: false,
                                isComplete: true,
                                Component: ({ changeCompletionStatus }) => (
                                    <Form
                                        keepDirtyOnReinitialize
                                        initialValues={{
                                            newsletters: preSelectedNewsletters,
                                        }}
                                        onSubmit={(data) => { }}
                                        render={() => (
                                            <form>
                                                <FormSpy
                                                    onChange={(props) => {
                                                        changeCompletionStatus({
                                                            isComplete: true,
                                                            ...props?.values,
                                                        })
                                                    }}
                                                />
                                                {newsletters.map((Field, idx) => (
                                                    <Field
                                                        key={idx}
                                                        linkColor={linkColor}
                                                        newsletterFilter={'all'}
                                                        newsletters={productNewsletters}
                                                    />
                                                ))}
                                            </form>
                                        )}
                                    />
                                ),
                            },
                            customFields: {
                                required: true,
                                isComplete: customFieldsValid,
                                Component: ({ changeCompletionStatus }) => (
                                    <Form
                                        onSubmit={() => { }}
                                        render={() =>
                                            !!fields.length && (
                                                <form>
                                                    <FormSpy
                                                        onChange={(props) => {
                                                            customFieldsValid = isCustomFieldsValid(fields, props?.values)

                                                            if (customFieldsValid) {
                                                                changeCompletionStatus({
                                                                    isComplete: true,
                                                                    ...props?.values,
                                                                })
                                                            }
                                                        }}
                                                    />
                                                    {fields.map((Field, idx) => (
                                                        <Field
                                                            key={idx}
                                                        />
                                                    ))}
                                                </form>
                                            )
                                        }
                                    />
                                ),
                            },
                        }}
                    />
                )}
            />
        </WizardSlider>
    )
}

export default OfferOptions
